import { render, staticRenderFns } from "./CloseBatchCard.vue?vue&type=template&id=4a3176b4&scoped=true&"
import script from "./CloseBatchCard.vue?vue&type=script&lang=js&"
export * from "./CloseBatchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3176b4",
  null
  
)

export default component.exports